import BaseProxy from '@manager/api/base-proxy';
import {
  IRequestFilterOptions,
  IResponse,
} from '@manager/api/types/general-types';
import type {
  IUserCreatePayload,
  IUserDetail,
  IUserEmailList,
  IUserList,
  IUserUpdateGeneralPayload,
} from '@manager/api/types/user-types';
import { getApiBasePath } from '@manager/utils/request-utils';

class UserService extends BaseProxy<
  IUserList,
  IUserDetail,
  IUserCreatePayload,
  IUserDetail,
  Partial<IUserUpdateGeneralPayload>,
  IUserDetail
> {
  constructor() {
    super('user');
  }

  getUserEmails(
    filter?: IRequestFilterOptions
  ): Promise<IResponse<IUserEmailList>> {
    return this.httpClient.get(`${getApiBasePath()}/autocomplete/user-email`, {
      params: filter,
    });
  }
}

export const userService = new UserService();
